import React from 'react'
import Select, {components} from 'react-select'

import Homme from '../../assets/logoHomme.svg'
import Femme from '../../assets/logoFemme.svg'

type listePrefix={
    icon: string, 
    value: string,
    label: string,
    lengthPhone: number, 
    code: string

}
interface Props {
  formik: any
  isSelf: boolean
  optionsPrefix: listePrefix[]
}

const BeneficiaryInfo: React.FC<Props> = ({
  formik,
  isSelf,
  optionsPrefix,
}) => {

    const optionGenre = [
    { index: 26, code: 'female', name: 'Femme', image: Femme },
    { index: 25, code: 'male', name: 'Homme', image: Homme },
  ]

  const optionsLien = [
    { index: 0, code: 'FAMILY', name: 'Famille' },
    { index: 1, code: 'FRIEND', name: 'Amis' },
    { index: 2, code: 'SELF', name: 'Moi même' },
    { index: 3, code: 'OTHER', name: 'Autres' },
  ]
 
  return (
    <>
      {/* Prénom + Nom */}
      <div className="flex w-full gap-3 lg:flex-col">

        <div className="w-full">
          <label className="h3">
            Prénom <span className="text-[#EE443F]">*</span>
          </label>

          <input
            className={`${
              isSelf ? 'bg-[#F1F1FF] text-[#AEB6FB]' : ''
            } placeholder:text-[#D1D1FF] rounded-[16px] border border-[#AEB6FB] focus:border-[#5754E5] h-[56px] sm:h-[40px] text-[#5754E5] text-[16px] px-[10px] w-full outline-none`}
            name="firstName"
            placeholder="Prénom"
            value={formik.values.firstName}
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={isSelf}
          />

          <p className="text-[#EE443F] w-full text-[10px] mt-1 h-[15px]">
            {formik.touched.firstName && formik.errors.firstName}
          </p>
        </div>

        <div className="w-full">
          <label className="h3">
            Nom <span className="text-[#EE443F]">*</span>
          </label>

          <input
            className={`${
              isSelf ? 'bg-[#F1F1FF] text-[#AEB6FB]' : ''
            } placeholder:text-[#D1D1FF] rounded-[16px] border border-[#AEB6FB] focus:border-[#5754E5] h-[56px] sm:h-[40px] text-[#5754E5] text-[16px] px-[10px] w-full outline-none`}
            name="lastName"
            placeholder="Nom"
            value={formik.values.lastName}
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={isSelf}
          />

          <p className="text-[#EE443F] text-[10px] mt-1 h-[15px]">
            {formik.touched.lastName && formik.errors.lastName}
          </p>
        </div>

      </div>


      {/* Genre + Lien */}
      <div className="flex w-full gap-3 lg:flex-col">

        <div className="flex flex-col w-full">
          <label className="h3">
            Genre <span className="text-[#EE443F]">*</span>
          </label>

          <Select
            classNamePrefix="select"
            isSearchable={false}
            options={optionGenre}
            isDisabled={isSelf}
            value={
              optionGenre.find(
                item => item.code === formik.values.gender
              ) || null
            }
            onChange={(option) =>
              formik.setFieldValue(
                'gender',
                option?.code || ''
              )
            }
            onBlur={() =>
              formik.setFieldTouched('gender', true)
            }
            placeholder="Choisir un genre"
            getOptionValue={(option) => option.code}
            formatOptionLabel={item => (
              <div className="flex items-center gap-2">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-5 h-5"
                />
                <span>{item.name}</span>
              </div>
            )}
          />

          <p className="text-[#EE443F] text-[10px] mt-1 h-[15px]">
            {formik.touched.gender && formik.errors.gender}
          </p>
        </div>


        <div className="flex flex-col w-full">
          <label className="h3">
            Lien <span className="text-[#EE443F]">*</span>
          </label>

          <Select
            classNamePrefix="select"
            isSearchable={false}
            options={optionsLien}
            value={
              optionsLien.find(
                item => item.code === formik.values.relationship
              ) || null
            }
            onChange={(option) =>
              formik.setFieldValue(
                'relationship',
                option?.code || ''
              )
            }
            onBlur={() =>
              formik.setFieldTouched('relationship', true)
            }
            placeholder="Choisir un lien"
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.code}
          />

          <p className="text-[#EE443F] text-[10px] mt-1 h-[15px]">
            {formik.touched.relationship &&
              formik.errors.relationship}
          </p>
        </div>

      </div>


      {/* Préfixe + téléphone */}
      <div className="flex gap-3 lg:flex-col">

        <div className="flex flex-col w-full">
          <label className="h3">
            Préfixe <span className="text-[#EE443F]">*</span>
          </label>

          <Select
            classNamePrefix="select"
            className={optionsPrefix.length > 1 ? 'has-options' : 'no-options'}
            isSearchable={false}
            menuIsOpen={optionsPrefix.length === 1 ? false : undefined}
            options={optionsPrefix}
            value={
              optionsPrefix.find(
                item => item.label === formik.values.phonePrefix
              ) || null
            }
            onChange={(option) =>
              formik.setFieldValue(
                'phonePrefix',
                option?.label || ''
              )
            }
            onBlur={() =>
              formik.setFieldTouched('phonePrefix', true)
            }
            getOptionValue={(option) => option.label}
            formatOptionLabel={item => (
              <div className="flex z-50 items-center gap-2">
                <img
                  src={item.icon}
                  alt={item.code}
                  className="w-5 h-5"
                />
                <span>{item.value}</span>
              </div>
            )}
            
             menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
          />

          <p className="text-[#EE443F] text-[10px] mt-1 h-[15px]">
            {formik.touched.phonePrefix &&
              formik.errors.phonePrefix}
          </p>
        </div>


        <div className="w-full">
          <label className="h3">
            Numéro de téléphone{' '}
            <span className="text-[#EE443F]">*</span>
          </label>

          <input
            className="placeholder:text-[#D1D1FF] rounded-[16px] border border-[#AEB6FB] focus:border-[#5754E5] h-[56px] sm:h-[40px] text-[#5754E5] text-[16px] px-[10px] w-full outline-none"
            name="phoneNumber"
            inputMode="numeric"

            placeholder="Numéro de téléphone"
            value={formik.values.phoneNumber}
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            onKeyDown={(e) => {
                if (
                !/[0-9]/.test(e.key) &&
                !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)
                ) {
                e.preventDefault()
                }
            }}
          />

          <p className="text-[#EE443F] text-[10px] mt-1 h-[15px]">
            {formik.touched.phoneNumber &&
              formik.errors.phoneNumber}
          </p>
        </div>

      </div>
    </>
  )
}

export default BeneficiaryInfo